import i18n from '@/utils/i18n';
import React from 'react';
import { Badge, BadgeSize, BadgeVariant } from '@usepepper/ui/atoms/badge';
import { createStyles } from '@/contexts/theme-context';
import { Tooltip, Typography } from '@usepepper/sprout-kit-ui';
import { View } from 'react-native';

interface Props {
  editsCount: number;
}

export const PricingEditsBadge: React.FC<Props> = ({ editsCount }) => {
  const [styles] = useStyles();

  return (
    <Tooltip offset={4} placement="top">
      <Tooltip.Trigger>
        <View style={styles.trigger}>
          <Badge
            label={String(editsCount)}
            size={BadgeSize.SMALL}
            variant={BadgeVariant.INFO}
          />
        </View>
      </Tooltip.Trigger>
      <Tooltip.Content
        animation={null}
        backgroundColor="$bgPrimaryDark"
        borderRadius="$4"
        paddingHorizontal="$8"
        paddingVertical="$4"
      >
        <Typography bold color="$textOnDark" size="$sm">
          {i18n.t(
            editsCount === 1
              ? 'pricing.table.badge.edit_count.singular'
              : 'pricing.table.badge.edit_count.plural',
            { count: editsCount },
          )}
        </Typography>
      </Tooltip.Content>
    </Tooltip>
  );
};

const useStyles = createStyles(() => ({
  trigger: {
    flexShrink: 0,
  },
}));
